<template>
  <div>
    <div v-if="className == 'mk-subject-serve'" class="mk-subject-serve">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="mk-subject-serve-list">
        <div class="swiper mk-subject-serve-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in childItem.propsValue.data.slice(0, 1)"
              :key="index"
            >
              <div class="mk-subject-serve-img">
                <img :src="item.customField1" alt />
              </div>
              <div class="mk-subject-serve-title">{{ item.customField2 }}</div>
              <div class="mk-subject-serve-summary">{{ item.customField3 }}</div>
              <div class="mk-subject-serve-btn">
                <img
                  v-if="item.customField4.text"
                  src="https://mks.yybip.com/group1/M00/0B/5E/CgoRC2iC3C-AOfYUAAAhyh8FvCY479.png"
                  alt
                />
                <img
                  v-if="item.customField5.text"
                  src="https://mks.yybip.com/group1/M00/03/AE/CgoRDGiC27GAEFUqAAAf-mAzG_8477.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="className == 'mk-subject-company'" class="mk-subject-company">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="mk-subject-company-list">
        <div class="swiper mk-subject-company-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in childItem.propsValue.data.slice(0, 1)"
              :key="index"
            >
              <div class="mk-subject-company-img">
                <img :src="item.customField1" alt />
              </div>
              <div class="mk-subject-company-title">{{item.customField2}}</div>
              <div class="mk-subject-company-summary">{{item.customField3}}</div>
              <div class="mk-subject-company-detail">
                <span v-if="item.customField4.text">{{ item.customField4.text }}</span>
                <span v-if="item.customField5.text">{{ item.customField5.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
export default {
  name: "MkContentCardPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    className() {
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      return selectClass.value;
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "logo",
          type: "image",
          width: 150,
          height: 20
        },
        {
          code: "customField2",
          label: "标题",
          type: "text"
        },
        {
          code: "customField3",
          label: "描述",
          type: "text"
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField5",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField6",
          label: "背景",
          type: "image",
          width: 350,
          height: 246
        },
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
          customField2: "标题",
          customField3: "描述信息",
          customField4: _.cloneDeep(buttonObject),
          customField5: _.cloneDeep(buttonObject),
          customField6: ""
        },
        {
          customField1:
            "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
          customField2: "标题",
          customField3: "描述信息",
          customField4: _.cloneDeep(buttonObject),
          customField5: _.cloneDeep(buttonObject),
          customField6: ""
        },
        {
          customField1:
            "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
          customField2: "标题",
          customField3: "描述信息",
          customField4: _.cloneDeep(buttonObject),
          customField5: _.cloneDeep(buttonObject),
          customField6: ""
        },
        {
          customField1:
            "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
          customField2: "标题",
          customField3: "描述信息",
          customField4: _.cloneDeep(buttonObject),
          customField5: _.cloneDeep(buttonObject),
          customField6: ""
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-serve {
  padding: 0.56rem 0.42rem 0.4rem;
  background-color: #fff;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.56rem;
  }
  .mk-subject-serve-list {
    position: relative;
    padding: 0 0.27rem;
    padding-bottom: 0.4rem;
  }
  .mk-subject-serve-swiper .swiper-slide {
    border: 1px solid #ccc;
    border-radius: 0.2rem;
    padding: 0.41rem 0.35rem;
    box-sizing: border-box;
  }
  .mk-subject-serve-img {
    display: flex;
    width: 2.34rem;
    margin-bottom: 0.3rem;
    img {
      width: 100%;
      height: auto;
    }
  }
  .mk-subject-serve-title {
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 0.26rem;
    color: #515051;
    line-height: 0.42rem;
    text-align: left;
    margin-bottom: 0.1rem;
  }
  .mk-subject-serve-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.21rem;
    color: #717071;
    line-height: 0.35rem;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0.5rem;
  }
  .mk-subject-serve-btn {
    height: 0.58rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-bottom: 0.17rem;
  }
  img {
    height: 100%;
    width: auto;
  }
}

.mk-subject-company {
  padding: 0.56rem 0.42rem 0.4rem;
  background-color: #f9f9f9;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.44rem;
  }
  .mk-subject-company-list {
    position: relative;
    padding-bottom: 0.4rem;
  }
  .mk-subject-company-swiper .swiper-slide {
    background-color: #fff;
    border-radius: 0.2rem;
    padding-bottom: 0.4rem;
  }
  .mk-subject-company-img {
    border-top: 0.03rem solid #e60012;
    margin-left: 0.4rem;
    padding-top: 0.4rem;
    display: flex;
    width: 1.8rem;
    margin-bottom: 0.4rem;
    img {
      width: 100px;
      height: auto;
    }
  }
  .mk-subject-company-title {
    margin: 0 0.4rem;
    font-family: AlibabaPuHuiTi_3_95_ExtraBold;
    font-size: 0.26rem;
    color: #515051;
    line-height: 0.42rem;
    text-align: left;
    font-weight: bolder;
  }
  .mk-subject-company-summary {
    margin: 0 0.4rem;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.22rem;
    color: #515051;
    line-height: 0.42rem;
    text-align: left;
    margin-bottom: 0.6rem;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mk-subject-company-detail {
    text-align: left;
    span {
      margin: 0 0.4rem;
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 0.22rem;
      color: #515051;
      line-height: 0.42rem;
    }
  }
}
</style>